// src/pages/EditarPerfilTab.jsx
import React from 'react';
import InputMask from 'react-input-mask';

export default function EditarPerfilTab({
  dados,
  loading,
  preview,
  previewCapa,
  onChange,
  onSubmit,
  onPickFoto,
  onPickCapa,
}) {
  const cidadesMT = [
    'Cuiabá',
    'Rondonópolis',
    'Sinop',
    'Sorriso',
    'Várzea Grande',
  ];

  const estadosBR = [
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MG',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'PR',
    'RJ',
    'RN',
    'RO',
    'RR',
    'RS',
    'SC',
    'SE',
    'SP',
    'TO',
  ];

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Foto de perfil */}
      <div className="col-span-2 flex items-center space-x-4">
        {preview && (
          <img
            src={preview}
            alt="Foto de perfil"
            className="w-24 h-24 rounded-full object-cover border-2 border-blue-500 shadow"
          />
        )}
        <label className="cursor-pointer text-blue-600 underline">
          <input type="file" accept="image/*" onChange={onPickFoto} hidden />
          Alterar foto de perfil
        </label>
      </div>

      {/* Capa */}
      <div className="col-span-2 flex flex-col mt-4 space-y-2">
        {previewCapa && (
          <img
            src={previewCapa}
            alt="Capa do perfil"
            className="w-full h-40 object-cover rounded-xl border shadow-sm"
          />
        )}
        <label className="cursor-pointer text-blue-600 underline">
          <input type="file" accept="image/*" onChange={onPickCapa} hidden />
          Alterar imagem de capa do perfil
        </label>
      </div>

      <input
        type="text"
        name="nome"
        placeholder="Nome Completo"
        value={dados.nome}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      />

      <InputMask
        mask="(99) 99999-9999"
        value={dados.telefone}
        onChange={onChange}
      >
        {(inputProps) => (
          <input
            {...inputProps}
            name="telefone"
            placeholder="Telefone"
            className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
            required
          />
        )}
      </InputMask>

      <InputMask mask="999.999.999-99" value={dados.cpf} onChange={onChange}>
        {(inputProps) => (
          <input
            {...inputProps}
            name="cpf"
            placeholder="CPF"
            className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
            required
          />
        )}
      </InputMask>

      <input
        type="text"
        name="creci"
        placeholder="CRECI"
        value={dados.creci}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      />

      <select
        name="especialidade"
        value={dados.especialidade}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 col-span-2"
      >
        <option value="">Selecione sua especialidade</option>
        <option value="residencial">Corretor de imóveis residenciais</option>
        <option value="comercial">Corretor de imóveis comerciais</option>
        <option value="alto_padrao">Corretor de imóveis de alto padrão</option>
        <option value="empreendimentos">Corretor de empreendimentos</option>
        <option value="rural">Corretor de imóveis rurais</option>
      </select>

      <textarea
        name="descricao"
        placeholder="Descrição"
        value={dados.descricao}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 col-span-2"
      />

      <select
        name="cidade"
        value={dados.cidade}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      >
        <option value="">Selecione a cidade</option>
        {cidadesMT.map((cidade) => (
          <option key={cidade} value={cidade}>
            {cidade}
          </option>
        ))}
      </select>

      <select
        name="estado"
        value={dados.estado}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      >
        <option value="">UF</option>
        {estadosBR.map((uf) => (
          <option key={uf} value={uf}>
            {uf}
          </option>
        ))}
      </select>

      <input
        type="text"
        name="bairro"
        placeholder="Bairro"
        value={dados.bairro}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      />

      <input
        type="text"
        name="rua"
        placeholder="Rua"
        value={dados.rua}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      />

      <input
        type="text"
        name="numero"
        placeholder="Número"
        value={dados.numero}
        onChange={onChange}
        className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500"
        required
      />

      <button
        type="submit"
        disabled={loading}
        className="col-span-2 bg-blue-600 hover:bg-blue-800 text-white font-semibold py-3 rounded-xl transition disabled:opacity-60"
      >
        {loading ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </form>
  );
}
